module.exports = __webpack_public_path__ + "media/esophageal varices.e1ad34f0.wav";